import { render, staticRenderFns } from "./invitationTask.vue?vue&type=template&id=887d7456&"
import script from "./invitationTask.vue?vue&type=script&lang=js&"
export * from "./invitationTask.vue?vue&type=script&lang=js&"
import style0 from "./invitationTask.vue?vue&type=style&index=0&id=887d7456&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports